import React from 'react';

const Craftsmanship = () => {
  return (
    <section id="craftsmanship" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="grid-two-column">
          <div>
            <div style={{ 
              width: '100%', 
              height: '600px', 
              background: 'var(--bg-secondary)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--text-light)'
            }}>
              <span className="body-regular">Craftsmanship Image</span>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>Artisanal Excellence</h2>
            <div className="content-spacing">
              <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                Every SOLENNE shoe is a testament to generations of Italian shoemaking tradition. Our master artisans dedicate over 200 hours to each pair, ensuring unparalleled quality and attention to detail.
              </p>
              <div>
                <h3 className="heading-3" style={{ marginBottom: '12px' }}>Our Process</h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                  From selecting the finest leathers to the final hand-polishing, each step is performed with meticulous care. We use only premium materials sourced from the world's most renowned tanneries.
                </p>
              </div>
              <div>
                <h3 className="heading-3" style={{ marginBottom: '12px' }}>Timeless Design</h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                  Our designs blend classic silhouettes with contemporary elegance, creating shoes that transcend seasonal trends and become cherished wardrobe essentials.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Craftsmanship;
